// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"XR-z","inlineTitle":"YR-z","sponsoredAdsWrapper":"ZR-z","marketplaceRecosWrapper":"_R-z"};